module.exports = __webpack_public_path__ + "img/icon-info.ac7a5b36.svg";